import React from 'react';
import { components } from 'react-select';
import arrowDown from '../../assets/img/arrow-down.svg';

function DropdownIndicator(props) {
    return (
        <components.DropdownIndicator {...props}>
            <img src={arrowDown} alt="Arrow" />
        </components.DropdownIndicator>
    );
}

export default DropdownIndicator;
